import useMembership from '@space-shell/common/hooks/useMembership'
import useMutation from '@space-shell/common/hooks/useMutation'
import type { PropsAssociateOrDissociateItemList } from '@space-shell/common/services/communities'
import { CommunitiesEndpoints } from '@space-shell/common/services/communities'
import { CommunitiesService } from '@space-shell/common/services/communities'
import { queryClient } from '@space-shell/config/request'
import type { ApiError } from '@space-shell/config/request/manager'
import type { UseMutationResult } from '@tanstack/react-query'

export type useAssociateOrDissociateCommunityReturn = {
  associateOrDissociateCommunity: UseMutationResult<
    void,
    ApiError,
    { body: PropsAssociateOrDissociateItemList }
  >
  invalidateQueries: () => Promise<[void]>
}

export const useAssociateOrDissociateCommunity = (): useAssociateOrDissociateCommunityReturn => {
  const { membershipSlug } = useMembership()

  return {
    associateOrDissociateCommunity: useMutation(({ body }) =>
      CommunitiesService.associateCommunity(membershipSlug, body)
    ),
    invalidateQueries: () =>
      Promise.all([
        queryClient.invalidateQueries([CommunitiesEndpoints.getCourses(membershipSlug)])
      ])
  }
}
